import { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { getDaysString, capitalize } from 'utils/Common';
import { CollectionModel } from 'model/collection/CollectionModels';
import { Chip } from '@mui/material';
import { IconButton, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export class CollectionProps {
  collection: CollectionModel;
  selected?: boolean;
  onClick: any;
}

export const Collection: FunctionComponent<CollectionProps> = ({ collection, selected, onClick }) => {

  return (<div style={
    {display: 'flex', alignItems: 'center'}}>
        {!collection.tested && (
              <Tooltip title="The collection has not been tested, click edit to test it" arrow placement="left" enterTouchDelay={0} leaveTouchDelay={3000}>
                <IconButton aria-label="Collection not tested" sx={{width: '40px', marginLeft: "-12px", marginRight: "12px"}}><WarningAmberIcon aria-hidden="true" /></IconButton>
              </Tooltip>
            )}
        <div onClick={onClick} className="follow-up-preview" style={{flex: 1}}>
            <Grid container>
          <Grid size="grow">
            <Typography variant="h6" sx={{fontSize: "1rem !important"}}>
              {collection.title}
            </Typography>
          </Grid>
          <Grid style={{width: "100px"}}>
            <Typography variant="body1">
              <span style={{float: "right", marginTop: "6px"}}>
                {collection.status === "paused" ? 
                  <Chip label="Paused" variant="outlined" className='chip' />: 
                collection.status === "expired" ?
                <Chip label="Expired" variant="outlined" className='chip' />:
                  getDaysString(collection.daysUntilNext)                    
                }
              </span>
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size="grow">
            <Typography sx={{ fontSize: 16, wordBreak:"break-word", whiteSpace: "normal"}} color="text.secondary" style={{marginBottom: "6px"}}>
              {collection.recipient}
            </Typography>
          </Grid>
          <Grid style={{width: "100px"}}>
            <Typography sx={{ fontSize: 16, wordBreak:"break-word", whiteSpace: "normal", textAlign: "right"}} color="text.secondary" style={{marginBottom: "6px"}}>
                {`$${collection.amount.toLocaleString()}/${capitalize(collection.schedule).slice(0,-2)}`}
            </Typography>
          </Grid>
        </Grid>

        {/* <Typography color="text.secondary">
        </Typography>
        <div className="collection-status">
          <Typography sx={{mb: 1}} color="text.secondary">
            {
              collection.status === "paused"?
              <>Paused</>:
              <><span>{getStatusString(collection.endDate, collection.upcoming)}</span></>
            }
          </Typography>
        </div> */}
  </div>
  </div>)
}
export default Collection;